import React from "react";
import Solution from "./components/Solution";
const Problem2 = () => {
  return (
    <div className="p-4">
      <h1 className="">Problem 2</h1>
      <p className="">
        <div className="">Create a stop watch</div>
      </p>
      <Solution />
    </div>
  );
};

export default Problem2;
